import { useEffect } from 'react';
import { MfeConfig } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import mfeConfig from 'Utils/mfeConfig';
import { FooterWrapper } from './Footer.styles';

const Footer = () => {
  useEffect(() => MfeConfig(mfeConfig), []);

  return (
    <FooterWrapper>
      <MfeReactComponent module="FooterModule" component="default" />
    </FooterWrapper>
  );
};

export default Footer;
